import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

const Sidebar = ({visible, onClose, balance}) => {
  const [user, setUser] = useState(null);
  const [help, setHelp] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    const storedSetting = localStorage.getItem('setting');
    if (storedSetting) {
      setHelp(JSON.parse(storedSetting).help);
    }
  }, []);

  const _share = () => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      const shareData = {
        title: 'Referral Link',
        text: `Refer your friends and receive 5% commission lifetime on every loss bidding (booking) of your friends! Use Referral Code - ${userData.referal_code} \n https://play.google.com/store/apps/details?id=com.mgcompany&referrer=${userData.referal_code}`,
        url: 'https://play.google.com/store/apps/details?id=com.mgcompany',
      };
      if (navigator.share) {
        navigator.share(shareData).catch(error => {
          console.error('Error sharing', error);
        });
      } else {
        alert('Sharing not supported in this browser.');
      }
    }
  };

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to Logout?')) {
      localStorage.removeItem('user');
      navigate('/login');
    }
  };

  if (!visible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.sidebar}>
        <div style={styles.profile}>
          <div style={styles.avatarBg}>
            <img
              src="/images/winofluck.png"
              alt="Profile"
              style={styles.avatar}
            />
          </div>
          {user && <p style={{color: 'white'}}>{user.name}</p>}
          {user && <p style={{color: 'yellow'}}>{user.mobile}</p>}
          {balance != null && <p style={{color: 'white'}}>₹ {balance}</p>}
        </div>

        <div style={styles.mainMenu}>
          <div style={styles.menuSection}>
            <button
              style={styles.item}
              onClick={() => {
                onClose();
                navigate('/home');
              }}>
              <img src="/images/house.png" alt="Home" style={styles.icon} />
              <span style={styles.itemTxt}>Home Page</span>
            </button>

            <button
              style={styles.item}
              onClick={() => {
                onClose();
                navigate('/profile');
              }}>
              <img src="/images/user.png" alt="Profile" style={styles.icon} />
              <span style={styles.itemTxt}>Profile</span>
            </button>

            <button
              style={styles.item}
              onClick={() => alert('Change Password clicked')}>
              <img
                src="/images/lock.png"
                alt="Change Password"
                style={styles.icon}
              />
              <span style={styles.itemTxt}>Change Password</span>
            </button>

            <button
              style={styles.item}
              onClick={() => {
                onClose();
                navigate('/terms');
              }}>
              <img
                src="/images/agreement.png"
                alt="Terms"
                style={styles.icon}
              />
              <span style={styles.itemTxt}>Terms & Conditions</span>
            </button>
          </div>

          <div style={styles.menuSection}>
            <button
              style={styles.item}
              onClick={() => {
                if (help && help.text) {
                  window.open(`https://wa.me/91${help.text}`, '_blank');
                }
              }}>
              <img
                src="/images/whatsapp_g.png"
                alt="Helpline"
                style={styles.icon}
              />
              <span style={styles.itemTxt}>Helpline</span>
            </button>

            <button style={styles.item} onClick={_share}>
              <img src="/images/sharing.png" alt="Share" style={styles.icon} />
              <span style={styles.itemTxt}>Share with Friends</span>
            </button>

            <button style={styles.item} onClick={handleLogout}>
              <img src="/images/logout.png" alt="Logout" style={styles.icon} />
              <span style={styles.itemTxt}>Logout</span>
            </button>
          </div>
        </div>
      </div>
      <div style={styles.blank} onClick={() => onClose()}></div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    zIndex: 1000,
  },
  sidebar: {
    width: '70%',
    maxWidth: '300px',
    backgroundColor: '#201305',
    display: 'flex',
    flexDirection: 'column',
  },
  blank: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  profile: {
    backgroundColor: '#001f34',
    alignItems: 'center',
    textAlign: 'center',
    padding: '20px 10px',
  },
  avatarBg: {
    height: '100px',
    width: '100px',
    borderRadius: '20px',
    overflow: 'hidden',
    margin: '0 auto 10px',
  },
  avatar: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  mainMenu: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  menuSection: {
    padding: '10px 0',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 20px',
    background: 'none',
    border: 'none',
    color: 'white',
    textAlign: 'left',
    width: '100%',
    cursor: 'pointer',
    fontSize: '16px',
  },
  icon: {
    width: '25px',
    height: '25px',
    marginRight: '10px',
  },
  itemTxt: {
    fontWeight: 'bold',
  },
};

export default Sidebar;
